import React from 'react';

interface TutorialOverlayProps {
  onClose: () => void;
}

export function TutorialOverlay({ onClose }: TutorialOverlayProps) {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000); // Auto-hide after 4 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-[45] pointer-events-none"
      onClick={onClose}
      style={{ touchAction: 'none' }}
    >
      <div className="absolute top-16 left-0 right-0 flex flex-col items-center">
        <div className="flex flex-col items-center animate-tutorial-fade">
          <div className="relative">
            <div className="w-6 h-6 rounded-full bg-white/90 absolute top-0 left-0 animate-tutorial-finger" />
            <div className="w-12 h-12 rounded-full border-2 border-white/30 animate-tutorial-ripple" />
          </div>
          <p className="text-white/90 text-base font-medium mt-4 text-center px-4">
            Swipe down to see more
          </p>
        </div>
      </div>
    </div>
  );
}